module.exports = __webpack_public_path__ + "static/img/logo_uid_stanfordmedicine.5758944.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_uid_stanfordmedicine.svg
// module id = LK6E
// module chunks = 1